import { locationResultsConstants } from '../_constants';
import { locationResultsService } from '../_services';

export const locationResultsActions = {
  casualTimes,
  deleteTime,
};

function casualTimes(locationId) {
  return (dispatch) => {
    dispatch(request(locationId));
    locationResultsService.casualResults(locationId).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };
  function request(data) {
    return { type: locationResultsConstants.GET_CASUAL_RESULTS_REQUEST, data };
  }
  function success(data) {
    return { type: locationResultsConstants.GET_CASUAL_RESULTS_SUCCESS, data };
  }
  function failure(error) {
    return { type: locationResultsConstants.GET_CASUAL_RESULTS_ERROR, error };
  }
}

function deleteTime(leaderboardId) {
  return (dispatch) => {
    dispatch(request(leaderboardId));
    locationResultsService.deleteResult(leaderboardId).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };
  function request(data) {
    return { type: locationResultsConstants.DELETE_RESULT_REQUEST, data };
  }
  function success(data) {
    return { type: locationResultsConstants.DELETE_RESULT_SUCCESS, data };
  }
  function failure(error) {
    return { type: locationResultsConstants.DELETE_RESULT_ERROR, error };
  }
}
